var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16095",
    "data-name": "Group 16095",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-Out",
    d: "M10.282,40a1.112,1.112,0,0,1-.2-.019.639.639,0,0,1-.132-.038.5.5,0,0,1-.211-.1l-.019-.011c-.023-.013-.038-.022-.038-.026a.744.744,0,0,1-.157-.125.932.932,0,0,1-.249-.431.847.847,0,0,1-.056-.313v-10.5a3.51,3.51,0,0,0,.618-.463A3.4,3.4,0,0,0,10.9,25.714h6.864A3.433,3.433,0,0,0,21.2,22.286V17.714a3.432,3.432,0,0,0-3.429-3.428H10.9a3.431,3.431,0,0,0-1.685-2.723V1.075a.859.859,0,0,1,.043-.3A.876.876,0,0,1,9.475.382.592.592,0,0,1,9.612.243a.993.993,0,0,1,.475-.219A.644.644,0,0,1,10.282,0h28.5a1.064,1.064,0,0,1,1.063,1.062V38.937A1.064,1.064,0,0,1,38.781,40ZM30.731,6.181a.589.589,0,0,1,.432.569V33.712a.591.591,0,0,1-.445.569l-13.93,3.586H37.713V2.131H16.275ZM25.743,18.65v3.156a.594.594,0,1,0,1.188,0V18.65a.594.594,0,1,0-1.188,0Zm-18.777,7.9-6.624-5.8a1,1,0,0,1,0-1.506l6.624-5.8a.981.981,0,0,1,.653-.25,1,1,0,0,1,1.005,1v2.368h9.286a1,1,0,0,1,1,1v4.857a1,1,0,0,1-1,1H8.625V25.8a1,1,0,0,1-1.006,1A.982.982,0,0,1,6.966,26.549Z",
    transform: "translate(221.844 320) rotate(180)",
    fill: "#0f5a9c",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/Check-Out.f8c6568b2402b8bfdc5a4bc42e979e50.svg";
export { ForwardRef as ReactComponent };